import { shortId } from '@bemor/web-kit';
import { Skeleton } from '@bemor/web-kit/ui';
import type { ReactNode } from 'react';

/**
 * What a detail page's header shows for its object (Nexroll's page-provided crumbs): the object's name, else its
 * short id; a skeleton while it loads (the kit then shows the current crumb as loading too).
 */
export function detailTitle(
    query: { data?: unknown; isError: boolean },
    name: string | null | undefined,
    id: string,
    prefix?: string,
): { title: ReactNode; documentTitle: string | undefined } {
    const known = query.data !== undefined || query.isError;
    const fallback = prefix ? `${prefix} ${shortId(id)}` : shortId(id);
    const label = known ? name?.trim() || fallback : undefined;
    return {
        title: label ?? (
            <Skeleton
                data-testid="title-loading"
                className="h-7 w-48 max-w-full"
            />
        ),
        documentTitle: label,
    };
}
